import { useEffect, useState } from 'react'
import styles from './PointsForm.module.scss'
import clsx from 'clsx'
import { Loader } from '../Loader/Loader'
import { useMachine, useActor } from '@xstate/react'
import { pointsFormMachine } from '../../xstate/points.machine'
import { AuthState } from '../../xstate/auth.machine'
import { DocsMachine } from '../../xstate/docs.machine'
import Select from 'react-select'
import InputMask from 'react-input-mask'

export function PointsForm() {
	const [stateFeedback, sendFeedback] = useMachine(pointsFormMachine)
	const [docsState] = useMachine(DocsMachine)
	const [stateAuth, sendAuth] = useActor(AuthState)
	const [isPolicy, setIsPolicy] = useState(false)
	const [policyDoc, setPolicyDoc] = useState(null)
	const [error, setError] = useState('')

	useEffect(() => {
		window.scrollTo({
			top: 0,
			behavior: 'smooth',
		})
		const certificateData = localStorage.getItem('certificate')
		if (certificateData) {
			sendFeedback({
				type: 'INPUT_CERTIFICATE',
				data: certificateData,
			})
		}
		const prizeData = localStorage.getItem('prize')
		if (certificateData) {
			sendFeedback({
				type: 'INPUT_PRIZE',
				data: prizeData,
			})
		}
	}, [])

	// useEffect(() => {
	// 	if (stateAuth.context?.email && stateAuth.context?.id && isPolicy) {
	// 		sendFeedback({
	// 			type: 'INPUT_EMAIL',
	// 			key: 'email',
	// 			data: stateAuth.context.email,
	// 		})
	// 	}
	// }, [])

	useEffect(() => {
		const personalDataDoc = docsState.context.docs.find(
			doc => doc.type === 'personal_data'
		)

		if (personalDataDoc) {
			setPolicyDoc(personalDataDoc.url)
		}
	}, [docsState])

	const handleSubmit = event => {
		event.preventDefault()
		if (!isPolicy) {
			setError('Вы должны согласиться с политикой конфиденциальности')
			return
		}
		setError('')
		sendFeedback({ type: 'SUBMIT' })
	}

	const [errors, setErrors] = useState({
		firstNameError: '',
		middleNameError: '',
		lastNameError: '',
		birthDateError: '',
		passportSeriesError: '',
		passportNumberError: '',
		issuedByError: '',
		departmentCodeError: '',
		issueDateError: '',
		genderError: '',
		innError: '',
		passportFileError: '',
		snilsFileError: '',
		snilsError: '',
	})
	useEffect(() => {
		if (stateFeedback.context.error) {
			const errorResponse =
				stateFeedback.context.error[0]?.response?.data?.errors

			const newErrors = {
				firstNameError: errorResponse?.name?.[0] || '',
				middleNameError: errorResponse?.middle_name?.[0] || '',
				lastNameError: errorResponse?.last_name?.[0] || '',
				birthDateError: errorResponse?.birth_date?.[0] || '',
				passportSeriesError: errorResponse?.passport_series?.[0] || '',
				passportNumberError: errorResponse?.passport_number?.[0] || '',
				issuedByError: errorResponse?.passport_issued_by?.[0] || '',
				genderError: errorResponse?.sex?.[0] || '',
				departmentCodeError: errorResponse?.passport_department_code?.[0] || '',
				issueDateError: errorResponse?.passport_issued_at?.[0] || '',
				passportFileError: errorResponse?.passport_file?.[0] || '',
				snilsFileError: errorResponse?.snils_file?.[0] || '',
				innError: errorResponse?.inn?.[0] || '',
				snilsError: errorResponse?.snils?.[0] || '',
			}

			setErrors(newErrors)
		}
	}, [stateFeedback.context.error])

	return (
		<section style={{ padding: '0' }} className={clsx(styles.feedbackForm)}>
			<div style={{ maxWidth: '645px' }} className={styles.wrapper}>
				{stateFeedback.matches('send') && (
					<div className={'fullPageLoader'}>
						<Loader />
					</div>
				)}
				<div className={styles.paragraph_start}>
					<p>
						<span>
							Вы в ТОПе лучших продавцов и ваши накопленные баллы&nbsp;
							<span style={{ color: '#AA3436' }}>превысили 4000 руб. </span>
						</span>
					</p>
					<p>
						Теперь нам необходимо отчитаться за вас в ФНС РФ (гл. 23 НК РФ).
					</p>
					<p>
						<b>Заполните, пожалуйста, форму ниже и мы все сделаем за вас.</b>
					</p>
					<p>
						Подробнее в п. 5.5 и 6 
						<a
							href='https://storage.yandexcloud.net/zictop.public/documents/rules.pdf'
							target='_blank'
						>
							Правил
						</a>
						.
					</p>{' '}
					<br />
				</div>

				{stateFeedback.matches('success') ? (
					<div className={styles.successMessage}>
						<p className={'h2'}>
							Ваши данные отправлены и&nbsp;находятся на&nbsp;проверке
						</p>
					</div>
				) : (
					<>
						{stateAuth.context.user_identities_status == 'verified' && (
							<h2>Данные подтверждены.</h2>
						)}
						{stateAuth.context.user_identities_status == 'new' && (
							<h2>Данные на проверке.</h2>
						)}
						{stateAuth.context.user_identities_status == 'no' && (
							<form onSubmit={handleSubmit}>
								<div className='formRow'>
									<label htmlFor='lastName'>Фамилия</label>
									<input
										id='lastName'
										type='text'
										value={stateFeedback.context.lastName}
										name='lastName'
										onChange={event => {
											sendFeedback({
												type: 'INPUT_LAST_NAME',
												key: 'lastName',
												data: event.target.value,
											})
										}}
									/>
									{errors.lastNameError && (
										<div className='errorMessage'>{errors.lastNameError}</div>
									)}

									{stateFeedback.context.errorMessage.map(item => {
										return (
											item.lastNameError !== '' && (
												<div className={'errorMessage'} key={'errLastName'}>
													{item.lastNameError}
												</div>
											)
										)
									})}
								</div>
								<div className='formRow'>
									<label htmlFor='firstName'>Имя</label>
									<input
										id='firstName'
										type='text'
										value={stateFeedback.context.firstName}
										name='firstName'
										onChange={event => {
											sendFeedback({
												type: 'INPUT_FIRST_NAME',
												key: 'firstName',
												data: event.target.value,
											})
										}}
									/>
									{errors.firstNameError && (
										<div className='errorMessage'>{errors.firstNameError}</div>
									)}
									{stateFeedback.context.errorMessage.map(item => {
										return (
											item.firstNameError !== '' && (
												<div className={'errorMessage'} key={'errFirstName'}>
													{item.firstNameError}
												</div>
											)
										)
									})}
								</div>
								<div className='formRow'>
									<label htmlFor='middleName'>Отчество</label>
									<input
										id='middleName'
										type='text'
										value={stateFeedback.context.middleName}
										name='middleName'
										onChange={event => {
											sendFeedback({
												type: 'INPUT_MIDDLE_NAME',
												key: 'middleName',
												data: event.target.value,
											})
										}}
									/>
									{errors.middleNameError && (
										<div className='errorMessage'>{errors.middleNameError}</div>
									)}
									{stateFeedback.context.errorMessage.map(item => {
										return (
											item.middleNameError !== '' && (
												<div className={'errorMessage'} key={'errMiddleName'}>
													{item.middleNameError}
												</div>
											)
										)
									})}
								</div>
								<div className='formRow'>
									<label htmlFor='gender'>Пол</label>
									<Select
										id='gender'
										className={'customSelectReact'}
										classNamePrefix={'custom'}
										isSearchable={false}
										value={
											stateFeedback.context.gender
												? {
														value: stateFeedback.context.gender,
														label:
															stateFeedback.context.gender === 'male'
																? 'Мужской'
																: 'Женский',
												  }
												: null
										}
										onChange={selectedOption => {
											sendFeedback({
												type: 'INPUT_GENDER',
												key: 'gender',
												data: selectedOption.value,
											})
										}}
										options={[
											{ value: 'male', label: 'Мужской' },
											{ value: 'female', label: 'Женский' },
										]}
										placeholder='Выберите пол'
									/>
									{errors.genderError && (
										<div className='errorMessage'>{errors.genderError}</div>
									)}
									{stateFeedback.context.errorMessage.map(item => {
										return (
											item.genderError !== '' && (
												<div className={'errorMessage'} key={'errGender'}>
													{item.genderError}
												</div>
											)
										)
									})}
								</div>
								<div className='formRow'>
									<label htmlFor='birthDate'>Дата рождения</label>
									<input
										id='birthDate'
										type='date'
										value={stateFeedback.context.birthDate}
										name='birthDate'
										onChange={event => {
											sendFeedback({
												type: 'INPUT_BIRTH_DATE',
												key: 'birthDate',
												data: event.target.value,
											})
										}}
									/>
									{errors.birthDateError && (
										<div className='errorMessage'>{errors.birthDateError}</div>
									)}
									{stateFeedback.context.errorMessage.map(item => {
										return (
											item.birthDateError !== '' && (
												<div className={'errorMessage'} key={'errBirthDate'}>
													{item.birthDateError}
												</div>
											)
										)
									})}
								</div>
								<div className={styles.flexRow}>
									<div className='formRow'>
										<label htmlFor='passportSeries'>Серия паспорта</label>
										<InputMask
											id='passportSeries'
											mask='99 99'
											value={stateFeedback.context.passportSeries}
											name='passportSeries'
											onChange={event => {
												sendFeedback({
													type: 'INPUT_PASSPORT_SERIES',
													key: 'passportSeries',
													data: event.target.value,
												})
											}}
										/>
										{errors.passportSeriesError && (
											<div className='errorMessage'>
												{errors.passportSeriesError}
											</div>
										)}
										{stateFeedback.context.errorMessage.map(item => {
											return (
												item.passportSeriesError !== '' && (
													<div
														className={'errorMessage'}
														key={'errPassportSeries'}
													>
														{item.passportSeriesError}
													</div>
												)
											)
										})}
									</div>

									<div className='formRow'>
										<label htmlFor='passportNumber'>Номер паспорта</label>
										<InputMask
											id='passportNumber'
											mask='999999'
											value={stateFeedback.context.passportNumber}
											name='passportNumber'
											onChange={event => {
												sendFeedback({
													type: 'INPUT_PASSPORT_NUMBER',
													key: 'passportNumber',
													data: event.target.value,
												})
											}}
										/>
										{errors.passportNumberError && (
											<div className='errorMessage'>
												{errors.passportNumberError}
											</div>
										)}
										{stateFeedback.context.errorMessage.map(item => {
											return (
												item.passportNumberError !== '' && (
													<div
														className={'errorMessage'}
														key={'errPassportNumber'}
													>
														{item.passportNumberError}
													</div>
												)
											)
										})}
									</div>
								</div>

								<div className='formRow'>
									<label htmlFor='issuedBy'>Кем выдан</label>
									<input
										id='issuedBy'
										type='text'
										value={stateFeedback.context.issuedBy}
										name='issuedBy'
										onChange={event => {
											sendFeedback({
												type: 'INPUT_ISSUED_BY',
												key: 'issuedBy',
												data: event.target.value,
											})
										}}
									/>
									{errors.issuedByError && (
										<div className='errorMessage'>{errors.issuedByError}</div>
									)}
									{stateFeedback.context.errorMessage.map(item => {
										return (
											item.issuedByError !== '' && (
												<div className={'errorMessage'} key={'errIssuedBy'}>
													{item.issuedByError}
												</div>
											)
										)
									})}
								</div>

								<div className={styles.flexRow}>
									<div className='formRow'>
										<label htmlFor='issueDate'>Дата выдачи</label>
										<input
											id='issueDate'
											type='date'
											value={stateFeedback.context.issueDate}
											name='issueDate'
											onChange={event => {
												sendFeedback({
													type: 'INPUT_ISSUE_DATE',
													key: 'issueDate',
													data: event.target.value,
												})
											}}
										/>
										{errors.issueDateError && (
											<div className='errorMessage'>
												{errors.issueDateError}
											</div>
										)}
										{stateFeedback.context.errorMessage.map(item => {
											return (
												item.issueDateError !== '' && (
													<div className={'errorMessage'} key={'errIssueDate'}>
														{item.issueDateError}
													</div>
												)
											)
										})}
									</div>
									<div className='formRow'>
										<label htmlFor='departmentCode'>Код подразделения</label>
										<InputMask
											id='departmentCode'
											mask='999-999'
											value={stateFeedback.context.departmentCode}
											name='departmentCode'
											onChange={event => {
												sendFeedback({
													type: 'INPUT_DEPARTMENT_CODE',
													key: 'departmentCode',
													data: event.target.value,
												})
											}}
										/>
										{errors.departmentCodeError && (
											<div className='errorMessage'>
												{errors.departmentCodeError}
											</div>
										)}
										{stateFeedback.context.errorMessage.map(item => {
											return (
												item.departmentCodeError !== '' && (
													<div
														className={'errorMessage'}
														key={'errDepartmentCode'}
													>
														{item.departmentCodeError}
													</div>
												)
											)
										})}
									</div>
								</div>
								<div className='formRow'>
									<label htmlFor='inn'>ИНН</label>
									<InputMask
										id='inn'
										mask='999999999999'
										value={stateFeedback.context.inn}
										name='inn'
										onChange={event => {
											sendFeedback({
												type: 'INPUT_INN',
												key: 'inn',
												data: event.target.value,
											})
										}}
									/>
									{errors.innError && (
										<div className='errorMessage'>{errors.innError}</div>
									)}
									{stateFeedback.context.errorMessage.map(item => {
										return (
											item.innError !== '' && (
												<div className={'errorMessage'} key={'errInn'}>
													{item.innError}
												</div>
											)
										)
									})}
								</div>
								<div className='formRow'>
									<label htmlFor='snils'>СНИЛС</label>
									<InputMask
										id='snils'
										mask='999-999-999 99'
										value={stateFeedback.context.snils}
										name='snils'
										onChange={event => {
											sendFeedback({
												type: 'INPUT_SNILS',
												key: 'snils',
												data: event.target.value,
											})
										}}
									/>
									{errors.snilsError && (
										<div className='errorMessage'>{errors.snilsError}</div>
									)}
									{stateFeedback.context.errorMessage.map(item => {
										return (
											item.snilsError !== '' && (
												<div className={'errorMessage'} key={'errSnils'}>
													{item.snilsError}
												</div>
											)
										)
									})}
								</div>
								<br />
								<p style={{ textAlign: 'left' }}>
									<b>Добавить фото</b>
								</p>
								<div className={styles.flexRow + ' ' + styles.photos}>
									<div className='formRow'>
										<label htmlFor='passportPhoto'>
											Паспорт
											<br />
											<img
												style={{ marginTop: '5px' }}
												src='/images/passport.svg'
												alt='Card'
											/>
										</label>

										<div className={styles.imagesContainer}>
											<div className={styles.imageInput}>
												<input
													id='passportPhoto'
													type='file'
													accept='image/*'
													onChange={event => {
														const file = event.target.files[0]
														if (file) {
															const preview = URL.createObjectURL(file)
															sendFeedback({
																type: 'INPUT_PASSPORT_PHOTO',
																key: 'passportPhoto',
																data: { file, preview },
															})
														}
													}}
												/>
											</div>
											{stateFeedback.context.passportPhoto && (
												<div className={styles.imagePreview}>
													<img
														src={stateFeedback.context.passportPhoto.preview}
														alt='Preview'
													/>
													<button
														type='button'
														className={styles.delete}
														onClick={() => {
															sendFeedback({
																type: 'DELETE_PASSPORT_PHOTO',
																key: 'passportPhoto',
																data: null,
															})
														}}
													>
														<svg
															width='26'
															height='26'
															viewBox='0 0 16 16'
															fill='none'
															xmlns='http://www.w3.org/2000/svg'
														>
															<path
																fillRule='evenodd'
																clipRule='evenodd'
																d='M3.646 3.646a.5.5 0 0 1 .708 0L8 7.293l3.646-3.647a.5.5 0 0 1 .708.708L8.707 8l3.647 3.646a.5.5 0 0 1-.708.707L8 8.707l-3.646 3.647a.5.5 0 0 1-.708-.708L7.293 8 3.646 4.354a.5.5 0 0 1 0-.708Z'
																fill='currentColor'
															/>
														</svg>
													</button>
												</div>
											)}
										</div>
										{errors.passportFileError && (
											<div className='errorMessage'>
												{errors.passportFileError}
											</div>
										)}
										{stateFeedback.context.errorMessage.map(item => {
											return (
												item.passportPhotoError !== '' && (
													<div
														className={'errorMessage'}
														key={'errPassportPhoto'}
													>
														{item.passportPhotoError}
													</div>
												)
											)
										})}
									</div>
									<div className='formRow'>
										<label htmlFor='snilsPhoto'>
											СНИЛС
											<br />
											<img
												style={{ marginTop: '5px' }}
												src='/images/snils.svg'
												alt='Card'
											/>
										</label>
										<div className={styles.imagesContainer}>
											<div className={styles.imageInput}>
												<input
													id='snilsPhoto'
													type='file'
													accept='image/*'
													onChange={event => {
														const file = event.target.files[0]
														if (file) {
															const preview = URL.createObjectURL(file)
															sendFeedback({
																type: 'INPUT_SNILS_PHOTO',
																key: 'snilsPhoto',
																data: { file, preview },
															})
														}
													}}
												/>
											</div>
											{stateFeedback.context.snilsPhoto && (
												<div className={styles.imagePreview}>
													<img
														src={stateFeedback.context.snilsPhoto.preview}
														alt='Preview'
													/>
													<button
														type='button'
														className={styles.delete}
														onClick={() => {
															sendFeedback({
																type: 'DELETE_SNILS_PHOTO',
																key: 'snilsPhoto',
																data: null,
															})
														}}
													>
														<svg
															width='26'
															height='26'
															viewBox='0 0 16 16'
															fill='none'
															xmlns='http://www.w3.org/2000/svg'
														>
															<path
																fillRule='evenodd'
																clipRule='evenodd'
																d='M3.646 3.646a.5.5 0 0 1 .708 0L8 7.293l3.646-3.647a.5.5 0 0 1 .708.708L8.707 8l3.647 3.646a.5.5 0 0 1-.708.707L8 8.707l-3.646 3.647a.5.5 0 0 1-.708-.708L7.293 8 3.646 4.354a.5.5 0 0 1 0-.708Z'
																fill='currentColor'
															/>
														</svg>
													</button>
												</div>
											)}
										</div>
										{errors.snilsFileError && (
											<div className='errorMessage'>
												{errors.snilsFileError}
											</div>
										)}
										{stateFeedback.context.errorMessage.map(item => {
											return (
												item.snilsPhotoError !== '' && (
													<div className={'errorMessage'} key={'errSnilsPhoto'}>
														{item.snilsPhotoError}
													</div>
												)
											)
										})}
									</div>
								</div>
								<br />

								<p
									className={styles.upkartablock}
									style={{ textAlign: 'left' }}
								>
									<b>Вы выбрали:</b>
									<div style={{ position: 'relative' }}>
										<img src='/images/upcarta.svg' alt='Card' />
										<span className={styles.pointValue}>
											{stateFeedback.context.certificate || ''}
										</span>
									</div>
								</p>

								<div className='formRow'>
									<input
										id='prize'
										type='hidden'
										value={localStorage.getItem('prize') || ''}
									/>
								</div>

								<div className={styles['field-group']}>
									<label className={styles['field-label']}>
										<input
											className={styles.checkbox}
											id='privacy_policy'
											name='privacy_policy'
											type='checkbox'
											checked={isPolicy}
											onChange={event => {
												setIsPolicy(event.target.checked)
												if (error) setError('')
											}}
										/>
										<span
											style={{ color: error && !isPolicy ? 'red' : 'inherit' }}
										>
											Я ознакомлен(а) с{' '}
											<a href={policyDoc ?? ''} target='__blank'>
												Политикой конфиденциальности
											</a>{' '}
											и согласен(сна) на обработку моих персональных данных в
											соответствии с{' '}
											<a href={policyDoc} target='__blank'>
												Политикой конфиденциальности
											</a>
										</span>
									</label>
								</div>

								{error && <div className={'errorMessage'}>{error}</div>}
								<div className='formRow'>
									<button
										type={'submit'}
										className={'btn btnPrimary ' + styles.sendButton}
									>
										Заказать
									</button>
								</div>
							</form>
						)}
					</>
				)}
			</div>
		</section>
	)
}
